export default "__VITE_ASSET__QtWO1qPs__"